import React, { useState } from 'react';

// Long free text (project brief) shown collapsed with a "more / less" toggle.
// The toggle stops propagation so it works inside clickable card headers.
export default function ExpandableText({ text, limit = 160, className = '' }) {
    const [open, setOpen] = useState(false);
    if (!text) return null;
    const long = text.length > limit;
    const shown = open || !long ? text : `${text.slice(0, limit).trimEnd()}…`;
    return (
        <p className={className}>
            {shown}
            {long && (
                <>
                    {' '}
                    <button type="button" className="expandable__link"
                        aria-expanded={open}
                        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
                        onKeyDown={(e) => e.stopPropagation()}>
                        {open ? 'less' : 'more'}
                    </button>
                </>
            )}
        </p>
    );
}
